import { useEffect } from 'react';
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet-async';
import ScrollProgress from 'src/components/scroll-progress';
import { Props } from 'src/features/@types/isSmallScreen';
import WhatsAppPopup from 'src/features/components/whatsAppPopup';
import { GlobalRefs, organization, scrollToSection } from 'src/features/global';
import DifferencesMobile from 'src/features/mobile/differencesMobile';
import Ads from 'src/features/sections/Ads';
import ContactUs from 'src/features/sections/contactus';
import Cover from 'src/features/sections/cover';
import Differences from 'src/features/sections/differences';
import Highlights from 'src/features/sections/highlights';
import Products from 'src/features/sections/products';
import { content } from './content';

// -----------------------------------------------------------------------------------------------

export default function Homepage({ isSmallScreen }: Props) {
  const { adsRef } = GlobalRefs();

  useEffect(() => {
    ReactGA.pageview(window.location.pathname);
  }, []);

  return (
    <>
      <Helmet>
        <title> Home {organization}</title>
      </Helmet>

      <ScrollProgress />

      {isSmallScreen ? (
        <Cover scrollToSection={scrollToSection} targetSectionRef={adsRef} resolution="mobile" />
      ) : (
        <Cover scrollToSection={scrollToSection} targetSectionRef={adsRef} />
      )}

      <Ads />

      <Products />

      {isSmallScreen ? <DifferencesMobile data={content} /> : <Differences data={content} />}

      <Highlights />

      {isSmallScreen ? <ContactUs resolution="mobile" /> : <ContactUs />}

      <WhatsAppPopup />
    </>
  );
}
